import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sites-terms',
  templateUrl: './sites_terms.html',
})
export class SitesTerms implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
